import apiClient from './apiClient';
import { InstanceAnalytics, TrendAnalytics } from '../types/analytics';
import { ResponseWithAnswersDto } from './feedbackService';

export const analyticsService = {
  async getInstanceAnalytics(instanceId: string, occurrenceId?: string): Promise<InstanceAnalytics> {
    const params = occurrenceId ? { occurrenceId } : {};
    const response = await apiClient.get(`/api/feedback-instances/${instanceId}/analytics`, { params });
    return response.data;
  },

  async getInstanceTrends(instanceId: string): Promise<TrendAnalytics> {
    const response = await apiClient.get(`/api/feedback-instances/${instanceId}/trends`);
    return response.data;
  },

  async getInstanceResponses(instanceId: string): Promise<ResponseWithAnswersDto[]> {
    const response = await apiClient.get(`/api/responses/instance/${instanceId}`);
    return response.data;
  },

  async deleteResponse(responseId: string): Promise<void> {
    await apiClient.delete(`/api/responses/${responseId}`);
  },

  async regenerateSummary(instanceId: string): Promise<{ aiSummary: string }> {
    const response = await apiClient.post(`/api/feedback-instances/${instanceId}/regenerate-summary`);
    return response.data;
  },
};

export default analyticsService;
